<template>
  <app-tooltip v-if="trialStatus" right>
    <template #activator="{ on }">
      <div class="icon" :data-e2e-id="kebab(trialStatus.text) + '-icon'" v-on="on">
        <component :is="trialStatus.icon" />
      </div>
    </template>
    {{ trialStatus.text }}
  </app-tooltip>
</template>

<script>
import _ from 'lodash'
import { TrialStatus } from '@/helpers/trial-helper'
import TrialStatusFeasibilityIcon from '@/assets/icons/TrialStatusFeasibilityIcon'
import TrialStatusOpenIcon from '@/assets/icons/TrialStatusOpenIcon'
import TrialStatusSuspendedIcon from '@/assets/icons/TrialStatusSuspendedIcon'
import TrialStatusClosedIcon from '@/assets/icons/TrialStatusClosedIcon'
import TrialStatusMatchingIcon from '@/assets/icons/TrialStatusMatchingIcon'

export default {
  components: {
    TrialStatusFeasibilityIcon,
    TrialStatusOpenIcon,
    TrialStatusSuspendedIcon,
    TrialStatusClosedIcon,
    TrialStatusMatchingIcon
  },
  props: {
    status: { type: String, default: null }
  },
  computed: {
    trialStatus() {
      return _.find(TrialStatus, it => it.value === this.status)
    }
  },
  methods: {
    kebab(selector) {
      return _.kebabCase(selector)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 30px;
  height: 30px;
}
</style>
